import {apiFetch} from './api.js'

export const createTeam = async (name, description, users, city, address) => {
    const endPoint = process.env.REACT_APP_URL_CREATE_TEAM

    try{
        const response = apiFetch(endPoint,  {
            method: 'POST',
            body: JSON.stringify({
                    name_team: name,
                    description_team: description,
                    users_team: users,
                    city_team: city,
                    address_team: address
            })
        })

        if(!response) return {status: false}

        const data = await response.json()

        return data
        
    }catch(err){
        console.error(err)
    }
}

export const showTeams = async (pageNumber) => {
    const endPoint = `${process.env.REACT_APP_URL_CREATE_TEAM}?page=${pageNumber}&limit=6`

    try{
        const response = await apiFetch(endPoint)

        if(!response) return {status: false}

        const data = await response.json()

        return data
        
    }catch(err){
        console.error(err)
    }
}

export const editUserTeam = async (id_team, id_user) => {
    const endPoint = process.env.REACT_APP_URL_EDIT_TEAM_USER

    try{
        const response = await apiFetch(endPoint, {
            method: 'POST',
            body: JSON.stringify({
                    id_team: id_team,
                    id_user: id_user
            })
        })
    }catch(err){
        console.error(err)
    }
}

export const deleteTeam = async (id_team) => {
    const endPoint = process.env.REACT_APP_URL_DELETE_TEAM

    try{
        const response = await apiFetch(endPoint, {
            method: 'DELETE',
            body: JSON.stringify({
                    id_team: id_team
            })
        })
    }catch(err){
        console.error(err)
    }
}

export const searchNameTeamByInitial = async(input) => {
    const endPoint = process.env.REACT_APP_URL_TEAM_SEARCH_NAME_BY_INITIAL

    try{
        const response = await apiFetch(endPoint + input)

        const data = await response.json()

        if(!response.ok) return {status: false}

        return data

    }catch(err){
        throw new Error(err)
    }
}